// Product card quantity stepper — syncs UI value to hidden [data-qty-input].
(function () {
  function init(root) {
    var input = root.querySelector('[data-qty-input]') || root.parentElement.querySelector('[data-qty-input]');
    var display = root.querySelector('[data-qty-value]');
    var dec = root.querySelector('[data-qty-decrease]');
    var inc = root.querySelector('[data-qty-increase]');
    if (!display || !dec || !inc) return;

    function set(next) {
      next = Math.max(1, next);
      display.textContent = String(next);
      if (input) input.value = String(next);
    }

    dec.addEventListener('click', function () { set(parseInt(display.textContent, 10) - 1); });
    inc.addEventListener('click', function () { set(parseInt(display.textContent, 10) + 1); });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-quantity]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
})();
